import PropTypes from 'prop-types';
import styled, { css } from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
const Wrapper = styled.div.withConfig({
  displayName: "DragHandle__Wrapper"
})(({
  theme,
  color
}) => {
  return css(["color:", ";line-height:0.3;margin:0 auto;white-space:pre-line;font-size:18px;"], color || theme.color['fill-tertiary-pressed']);
});
const DragHandleDots = ({
  color
}) => /*#__PURE__*/_jsx(Wrapper, {
  color: color,
  children: `
         ......
         ......
        `
});
DragHandleDots.propTypes = {
  color: PropTypes.string
};
export default DragHandleDots;